import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

const saveUserDetailsService = async (baseURL, requestBody) => {
  try {
    const saveUserDetailsRequestObj = {
      registrationParam: {
        vendorCode: requestBody?.vendorCode,
        vendorName: requestBody?.vendorName,
        firstName: requestBody?.SPOCFirstName,
        lastName: requestBody?.SPOCLastName,
        email: requestBody?.vendorSPOCemail,
        mobile: requestBody?.vendorSPOCMobile,
        applicationId: requestBody?.applicationId
          ? requestBody?.applicationId
          : null,
        gstin: requestBody?.gstin,
      },
    };
    const saveUserDetailsResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.saveUserDetails}`,
      JSON.stringify(saveUserDetailsRequestObj)
    );

    if (
      saveUserDetailsResponse?.status === 200 &&
      saveUserDetailsResponse.data
    ) {
      return saveUserDetailsResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export default saveUserDetailsService;
